@if (data()) {
<ng-content></ng-content>
} @else {
<div class="w-full h-[60vh] flex flex-col gap-4 justify-center items-center">
  <span class="loader"></span>

  @if (title()) {
  <div class="typewriter">
    <p class="loading-title">
      {{title() | transloco}}
    </p>
  </div>
  }
</div>
}
